import React from 'react';
import { Tooltip as NextUITooltip, type TooltipProps } from '@heroui/tooltip';

interface Props extends TooltipProps {
  children: React.ReactNode;
  disableMaxWidth?: boolean;
  maxWidth?: string;
}
const container = {
  hover: {
    opacity: 1
  },

  normal: {
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },

  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

function Tooltip(
  {
    children,
    showArrow = true,
    disableAnimation = true,
    classNames,
    disableMaxWidth = false,
    maxWidth,
    ...rest
  }: Props,
  ref: React.Ref<HTMLDivElement>
) {
  const maxWidthClass = disableMaxWidth ? '' : (maxWidth || 'max-w-[335px]');

  return (
    <NextUITooltip
      {...rest}
      ref={ref}
      initial="normal"
      whileHover="hover"
      animate="hover"
      variants={container}
      delay={0}
      closeDelay={0}
      classNames={
        classNames || {
          base: [`before:bg-black ${maxWidthClass}`],
          content: ['py-2 px-3 rounded-md text-xs', 'bg-black text-default-50 dark:text-grey-50'],
        }
      }
      showArrow={showArrow}
    >
      {children}
    </NextUITooltip>
  );
}

export default React.forwardRef(Tooltip);
